import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect } from "react";
import {
  isAndroid,
  isIOS,
} from "react-device-detect";

function App() {
  useEffect(() => {
     if (isAndroid) {
       return (window.location.href =
         "https://play.google.com/store/apps/details?id=com.almotahidaeducation.revision&hl=en_US&gl=US");
     } else if (isIOS) {
       return (window.location.href =
         "https://apps.apple.com/app/%D9%86%D8%A7%D9%81%D8%B3/id6443656367");
     } else {
       return (window.location.href = "https://nafes.app/web/main/courses");
     }
  
  }, [])
  

 
  return (
    <div className="App">
      <div className="loading text-center">
        <div className="spinner-grow " role="status"></div>
        <div className="spinner-grow " role="status"></div>
        <div className="spinner-grow " role="status"></div>
      </div>
    </div>
  );
}

export default App;
